import axios from 'axios';

const API_URL = import.meta.env.VITE_AMINID_API_URL || 'http://localhost:4008';

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('aminid_token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('aminid_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
